app.service("CacheBrowseService", ['$rootScope', function ($rootScope) {

    const service = this;

    const cacheVersion = 2;

    const CacheBrowseModel = function () {
        this.category_caches = {};
        this.category_cache_ids = null;
    };

    this.model = new CacheBrowseModel();
    const model = this.model;

    function requireCategoryCacheIDs() {
        if (model.category_cache_ids) {
            return
        }
        const cacheCategoryIDsName = 'cache_browse_category_ids';
        const json = localStorage.getItem(cacheCategoryIDsName);
        const categoryCacheIDs = json ? JSON.parse(json) : null;
        model.category_cache_ids = categoryCacheIDs ? categoryCacheIDs : {};
    }

    this.requireCategoryCache = function (categoryID, categoryCartID) {
        requireCategoryCacheIDs();
        let cache = model.category_caches[categoryID];
        if (cache) {
            cache.category_id = categoryID;
            return cache;
        }
        model.category_cache_ids[categoryID] = true;
        const cacheName = 'cache_browse_category_' + categoryID;
        const json = localStorage.getItem(cacheName);
        cache = json ? JSON.parse(json) : null;
        if (cache && cache.cache_version === cacheVersion) {
            model.category_caches[categoryID] = cache;
            return cache;
        }

        cache = {
            cache_version: cacheVersion,
            category_id: categoryID,
            input_choice_ids: {},
            option_term_ids: {},
            order_lines: [],
            category_cart_id: categoryCartID
        }
        model.category_caches[categoryID] = cache;
        return cache;
    }

    this.saveCategoryCache = function (categoryID) {
        let json;
        const cache = model.category_caches[categoryID];
        if (!cache) {
            return
        }
        requireCategoryCacheIDs();

        const cacheName = 'cache_browse_category_' + categoryID;
        const cacheCategoryIDsName = 'cache_browse_category_ids';

        json = JSON.stringify(model.category_cache_ids)
        localStorage.setItem(cacheCategoryIDsName, json);

        json = JSON.stringify(cache)
        localStorage.setItem(cacheName, json);

        $rootScope.$broadcast("category_cache_change", {category_id: categoryID});
    }

    this.removeCategoryCaches = function () {
        requireCategoryCacheIDs();

        const cacheCategoryIDsName = 'cache_browse_category_ids';
        const categoryCacheIDs = model.category_cache_ids;
        localStorage.removeItem(cacheCategoryIDsName);
        model.category_cache_ids = {};
        if (categoryCacheIDs) {
            for (let categoryID in categoryCacheIDs) {
                service.removeCategoryCache(categoryID, true)
            }
        }
    }

    this.removeCategoryCache = function (categoryID, idHandled) {
        requireCategoryCacheIDs();
        if (!idHandled) {
            const cacheCategoryIDsName = 'cache_browse_category_ids';
            delete model.category_cache_ids[categoryID];
            const json = JSON.stringify(model.category_cache_ids)
            localStorage.setItem(cacheCategoryIDsName, json);
        }
        const cacheName = 'cache_browse_category_' + categoryID;
        localStorage.removeItem(cacheName);
        delete model.category_caches[categoryID];
        $rootScope.$broadcast("category_cache_change", {category_id: categoryID});
    }

}]);